import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ServiceCardProps {
  title: string;
  services: string[];
  icon: React.ReactNode;
  backgroundColor: 'pink' | 'white';
  image: string;
  delay: number;
}
export function ServiceCard({
  title,
  services,
  icon,
  backgroundColor,
  image,
  delay
}: ServiceCardProps) {
  const bgClass = backgroundColor === 'pink' ? 'bg-pink/30' : 'bg-white';
  const shadowClass = backgroundColor === 'white' ? 'shadow-lg shadow-pink/20' : '';
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className={`${bgClass} ${shadowClass} rounded-2xl overflow-hidden border-t-4 border-gold hover:scale-105 transition-transform duration-300`} data-id="element-138">
      <div className="relative aspect-square md:aspect-[4/5] overflow-hidden" data-id="element-139">
        <img src={image} alt={title} className="w-full h-full object-cover object-center" data-id="element-140" />
      </div>

      <div className="p-6 space-y-4" data-id="element-141">
        <div className="flex items-center gap-3" data-id="element-142">
          <div className="text-gold" data-id="element-143">{icon}</div>
          <h3 className="text-2xl font-serif font-bold text-charcoal" data-id="element-144">
            {title}
          </h3>
        </div>

        <ul className="space-y-2" data-id="element-145">
          {services.map((service, index) => <li key={index} className="flex items-start gap-2 text-charcoal/80" data-id="element-146">
              <span className="text-gold mt-1" data-id="element-147">•</span>
              <span data-id="element-148">{service}</span>
            </li>)}
        </ul>

        <a href="https://vrbeautystudio.koob.uy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-gold text-white font-semibold rounded-full hover:bg-gold/90 transition-colors mt-4" data-id="element-149">
          Reservar turno
          <ArrowRight className="w-4 h-4" data-id="element-150" />
        </a>
      </div>
    </motion.div>;
}